// src/components/BookingCategoryItem.js

import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const BookingCategoryItem = ({ title, count, description, icon, to }) => (
    <ListItemButton component={RouterLink} to={to}>
        <ListItemIcon>
            {icon}
        </ListItemIcon>
        <ListItemText
            primary={`${title} (${count})`}
            secondary={description}
        />
    </ListItemButton>
);

BookingCategoryItem.propTypes = {
    title: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    to: PropTypes.string.isRequired,
};

export default BookingCategoryItem;
